import { useTranslation } from 'react-i18next';
import type { ConfidenceLevel, ConfidenceReason } from '@interfaces/IProductivity';
import { Tooltip } from '@components/ui/Tooltip/Tooltip';
import styles from './ConfidencePill.module.css';

interface IConfidencePillProps {
  level: ConfidenceLevel;
  reason?: ConfidenceReason;
}

export function ConfidencePill({ level, reason }: IConfidencePillProps) {
  const { t } = useTranslation();

  const label = t(`productivity.confidenceLevel.${level}`);
  const tooltip = reason ? t(`productivity.confidenceReason.${reason}`) : undefined;

  return (
    <Tooltip content={tooltip}>
      <span className={styles.pill} data-tone={level}>
        {label}
      </span>
    </Tooltip>
  );
}
